import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './Favo.scss';
import { getMergedClassNames } from '../../utils/HTMLUtils';

const rootClassName = styles.rootClassName;

class Favo extends Component {
  getPropSize = () => {
    return typeof this.props.size === 'number' && this.props.size > 0
      ? this.props.size
      : 20;
  };

  render() {
    const props = {
      className: getMergedClassNames([
        rootClassName,
        typeof this.props.className === 'string' ? this.props.className : '',
      ]),
      width: this.getPropSize(),
      height: this.getPropSize(),
      onClick:
        typeof this.props.onClick === 'function'
          ? (e) => this.props.onClick(e)
          : null,
    };
    return (
      <svg
        viewBox='0 0 54 50'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
      >
        <g
          fill={
            typeof this.props.color === 'string'
              ? this.props.color
              : styles.disabled
          }
        >
          <path d='M19.6243 0H34.374C38.7496 0 42.7919 2.33074 44.9766 6.11666L52.3576 18.8803C54.5423 22.6662 54.5423 27.3277 52.3576 31.1136L44.9827 43.8772C42.798 47.6631 38.7496 49.9938 34.3802 49.9938H19.6243C15.2488 49.9938 11.2065 47.6631 9.02181 43.8772L1.64695 31.1136C-0.537739 27.3277 -0.537739 22.6662 1.64695 18.8803L9.01564 6.11666C11.2065 2.33074 15.2488 0 19.6243 0Z' />
        </g>
      </svg>
    );
  }
}

Favo.propTypes = {
  className: PropTypes.string,
  size: PropTypes.number,
  color: PropTypes.string,
  onClick: PropTypes.func,
};

export default Favo;
